jQuery(document).ready(function() {
  jQuery("a.my-cart-link, .jsc-close-btn, #jsc-backdrop").click(function(e) {
    jQuery("#jsc").toggleClass("jsc-active");
    if($("#jsc").hasClass("jsc-active")){
      try {
        hj("event", "mini-cart-clicked");
        console.log("Sending mini-cart-clicked event to hj.");
      } catch (error) {
        console.log("Can't log event to hotjar: ", error);
      }
      $("body").css("overflow-y", "hidden");
    }else{
      $("body").css("overflow-y", "scroll");
    }
    jscInitCart();
    return false;
  });
});

const jscToggleCart = function(){
  jQuery("#jsc").toggleClass("jsc-active");
  if($("#jsc").hasClass("jsc-active")){
    try {
      hj("event", "mini-cart-clicked");
      console.log("Sending mini-cart-clicked event to hj.");
    } catch (error) {
      console.log("Can't log event to hotjar: ", error);
    }
    $("body").css("overflow-y", "hidden");
  }else{
    $("body").css("overflow-y", "scroll");
  }
  jscInitCart();
}

var jscCurrency = Shopify.currency.active;
var jscCurrencySymbol;
switch (jscCurrency) {
  case 'USD':
    jscCurrencySymbol = "$";
    break;

  case 'CAD':
    jscCurrencySymbol = "$";
    break;

  case 'AUD':
    jscCurrencySymbol = "$";
    break;

  case 'EUR':
    jscCurrencySymbol = "€";
    break;

  case 'GBP':
    jscCurrencySymbol = "£";
    break;
}

var jscCartData, jscCartCompare = "";

const jscInitCart = function() {
  jQuery.ajax({
    type: "GET",
    url: "//adinasjewels.com/cart.js",
    dataType: "json",
    success: function(data, status, xhr) {
      jscCartCompare = JSON.stringify(data.items);
      if (jscCartData == jscCartCompare) {
        return data;
      } else {
        //console.log("cart data not the same:" +data.items);
        if (data.item_count == 0) {
          jscEmptyCart();
        } else {
          jscPopulateCart(data);
        }
      }

      return data;
    },
    error: function(xhr, status, error) {
      console.log("JSC Cart Error: " + xhr.error);
      return "JSC Cart Error: " + xhr.error;
    }
  });
}

function jscPopulateCart(cart) {

  if (cart.item_count > 0) {
    var jscTemplate = jQuery("#jscCartTemplate").text();
    jQuery("#jsc-items").empty();
    jQuery("#jsc-items").removeClass("jsc-empty-cart");
    jQuery.each(cart.items, function(i, e) {
      
      if(e.product_title.indexOf("Free Engraving") !== -1){
      	return true;
      }
      
      var jscItem = jscTemplate;

      var jscItemPrice = Shopify.formatMoney(e.final_line_price);
      jscItemPrice = jscItemPrice.replace("$", jscCurrencySymbol);

      jscItem = jscItem.replace("{JSCIMG}", e.featured_image.url);
      jscItem = jscItem.replace("{JSCALT}", e.featured_image.alt);
      jscItem = jscItem.replace("{JSCTITLE}", e.product_title);

      if (!jQuery.isEmptyObject(e.properties)) {

        if(e.product_title == "Free Engraving"){
          jscItem = jscItem.replace("{JSCPROPERTY}", "");  
        }else{
          var jscItemProperties = '';
          jQuery.each(e.properties, function(i, e) {
            // SKIP ADDING PROPERTIES IF CONDITION MET
            if(i.indexOf("_io_order_group") !== -1){
              return true;
            }
            
            if(i.indexOf("Add Free Engraving") !== -1){
              jscItemProperties += "Free Engraving: Yes<br />";
              return true;
            }
            
            if(i.indexOf("Pre-order") !== -1){
              jscItemProperties += "Pre-order<br />";
              return true;
            }
            
            if(i.indexOf("Estimated shipping") !== -1){
              var jscEstShip = e;
              jscEstShip = jscEstShip.replace(" days", "");
              const d = new Date();
              d.setDate(d.getDate() + parseInt(jscEstShip));
              var jd_pp_ship_date = d.toDateString();
              jscItemProperties += "Est. shipping: "+jd_pp_ship_date+"<br />";
              return true;
            }

            jscItemProperties += i+": "+e+"<br />";
          });
          jscItem = jscItem.replace("{JSCPROPERTY}", jscItemProperties);
        }
      } else {
        jscItem = jscItem.replace("{JSCPROPERTY}", "");
      }

      if(e.product_title == "Free Engraving"){
        jscItem = jscItem.replace("{JSCVARIANT}", '');
        jscItem = jscItem.replace("{QUANTITYHIDE}", 'jsc-quantity-hidden');
      }else{
        jscItem = jscItem.replace("{JSCVARIANT}", e.variant_title);
        jscItem = jscItem.replace("{QUANTITYHIDE}", '');
      }

      jscItem = jscItem.replace("{JSCVARIANTID}", e.variant_id);
      jscItem = jscItem.replace("{JSCQUANTITY}", e.quantity);
      jscItem = jscItem.replace("{JSCPRICE}", jscItemPrice);
      jscItem = jscItem.replace("{JSCLINK}", e.url);

      jQuery(jscItem).appendTo(jQuery("#jsc-items"));
    });

    jQuery('body').on('click', 'button.jsc-quantity-adjuster', function() {
      if (jQuery(this).hasClass("jsc-minus")) {
        jscDecreaseQty(this);
      } else if (jQuery(this).hasClass("jsc-plus")) {
        jscIncreaseQty(this);
      }
    });

    jQuery('body').on('click', 'button.jsc-item-remove', function() {
      jscRemoveItem(this);
    });

    jscCartData = JSON.stringify(cart.items);

    jscPopulateCartTotals(cart);
  } else {
    return false;
  }
}

function jscEmptyCart() {
  jQuery("#jsc-items").addClass("jsc-empty-cart");
  jQuery("#jsc-items").html("<div class='jsc-empty-cart'>You do not have any items in the cart.</div>");
}

function jscPopulateCartTotals(cart) {
  var jscFooter = $("#jsc-footer");
  var jscSubtotalPrice = Shopify.formatMoney(cart.items_subtotal_price);
  jscSubtotalPrice = jscSubtotalPrice.replace("$", jscCurrencySymbol);
  var jscTotalPrice = Shopify.formatMoney(cart.total_price);
  jscTotalPrice = jscTotalPrice.replace("$", jscCurrencySymbol);

  $("#jsc-subtotal-price").text(jscSubtotalPrice);
  $("#jsc-total-price").text(jscTotalPrice);

}

function jscIncreaseQty(e) {
  $(e).closest(".jsc-quantity").addClass("disabled");
  var jscCurrentQuantity = parseInt($(e).siblings(".jsc-current-quantity").text());
  var jscItemId = $(e).closest("[data-variant]").attr("data-variant");
  var jscItemQty = (jscCurrentQuantity + 1);
  jQuery.post('/cart/change.js', {
    id: jscItemId,
    quantity: jscItemQty
  }, null, "json").done(function(data, status) {
    $(data.items).each(function(i, j) {
      if (j.id == jscItemId) {

        var jscItemPrice = Shopify.formatMoney(j.final_line_price);
        jscItemPrice = jscItemPrice.replace("$", jscCurrencySymbol);

        $(e).siblings(".jsc-current-quantity").text(j.quantity);
        $(e).closest(".jsc-item").find("#jsc-item-total-price").text(jscItemPrice);
        $(e).closest(".jsc-quantity").removeClass("disabled");
      }
    });
    jscPopulateCartTotals(data);
  }).fail(function(data, status) {
    console.log("JSC: Cannot update quantity due to an error: " + status);
    $(e).closest(".jsc-quantity").removeClass("disabled");
    jscPopulateCartTotals(data);
  });
}

function jscDecreaseQty(e) {
  $(e).closest(".jsc-quantity").addClass("disabled");
  var jscCurrentQuantity = parseInt($(e).siblings(".jsc-current-quantity").text());
  if (jscCurrentQuantity == 1) {
    $(e).closest(".jsc-quantity").removeClass("disabled");
    return;
  } else {
    var jscItemId = $(e).closest("[data-variant]").attr("data-variant");
    var jscItemQty = (jscCurrentQuantity - 1);
    jQuery.post('/cart/change.js', {
      id: jscItemId,
      quantity: jscItemQty
    }, null, "json").done(function(data, status) {
      $(data.items).each(function(i, j) {
        if (j.id == jscItemId) {

          var jscItemPrice = Shopify.formatMoney(j.final_line_price);
          jscItemPrice = jscItemPrice.replace("$", jscCurrencySymbol);


          $(e).siblings(".jsc-current-quantity").text(j.quantity);
          $(e).closest(".jsc-item").find("#jsc-item-total-price").text(jscItemPrice);
          $(e).closest(".jsc-quantity").removeClass("disabled");
        }
      });
      jscPopulateCartTotals(data);
    }).fail(function(data, status) {
      console.log("JSC: Cannot update quantity due to an error: " + status);
      $(e).closest(".jsc-quantity").removeClass("disabled");
      jscPopulateCartTotals(data);
    });
  }
}

function jscRemoveItem(e) {
  $(e).closest(".jsc-item").find(".jsc-quantity").addClass("disabled");
  var jscItemId = $(e).closest("[data-variant]").attr("data-variant");
  var jscItemFound = false;
  jQuery.post('/cart/change.js', {
    id: jscItemId,
    quantity: 0
  }, null, "json").done(function(data, status) {
    $(data.items).each(function(i, j) {
      if (j.id == jscItemId) {
        jscItemFound = true;
        return false;

      }
    });
    if (jscItemFound == true) {
      console.log("Item could not be removed due to an error.");
      $(e).closest(".jsc-item").find(".jsc-quantity").removeClass("disabled");
    } else {
      $(e).closest(".jsc-item").remove();
      jscPopulateCartTotals(data);
      if (data.item_count == 0) {
        jscEmptyCart();
      }
    }

  }).fail(function(data, status) {
    console.log("JSC: Cannot update quantity due to an error: " + status);
    $(e).closest(".jsc-item").find(".jsc-quantity").removeClass("disabled");
    jscPopulateCartTotals(data);
  });
}

jscInitCart();